import { useEffect } from "react";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { Nav } from "@/components/Nav";
import { Hero } from "@/components/Hero";
import { LogoMarquee } from "@/components/LogoMarquee";
import { Features } from "@/components/Features";
import { InfraBand } from "@/components/InfraBand";
import { HowItWorks } from "@/components/HowItWorks";
import { Pricing } from "@/components/Pricing";
import { Faq } from "@/components/Faq";
import { Reviews } from "@/components/Reviews";
import { FinalCta } from "@/components/FinalCta";
import { Footer } from "@/components/Footer";

const REVEAL_SELECTOR = ".rl-reveal";

function App() {
  useEffect(() => {
    const nodes = document.querySelectorAll(REVEAL_SELECTOR);
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("rl-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    nodes.forEach((node) => observer.observe(node));
    return () => observer.disconnect();
  }, []);

  return (
    <div
      className="min-h-screen bg-[#090d12] text-[#e2e8f0] antialiased selection:bg-[#22d3ee]/30 selection:text-white"
      data-testid="runloft-page"
    >
      <Nav />
      <main>
        <Hero />
        <LogoMarquee />
        <Features />
        <InfraBand />
        <HowItWorks />
        <Pricing />
        <Reviews />
        <Faq />
        <FinalCta />
      </main>
      <Footer />
      <Toaster theme="dark" position="bottom-right" />
    </div>
  );
}

export default App;
